import { useState } from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Ticket } from "@phosphor-icons/react";
import { toast } from "sonner";
import { SocialOtpAuth } from "@/components/SocialOtpAuth";

export default function Login() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const from = location.state?.from || "/";

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError("");
    const res = await login(email, password);
    setLoading(false);
    if (res.ok) {
      toast.success("Berhasil masuk");
      navigate(res.user.role === "admin" ? "/admin" : from, { replace: true });
    } else {
      setError(res.error);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-background grain px-5">
      <div className="w-full max-w-md">
        <Link to="/" className="flex items-center gap-2 mb-8 justify-center">
          <div className="w-9 h-9 bg-primary flex items-center justify-center neon-glow">
            <Ticket weight="fill" size={22} className="text-black" />
          </div>
          <span className="font-heading font-black text-2xl tracking-tighter">EVENT<span className="text-primary">KU</span></span>
        </Link>
        <div className="bg-card border border-white/10 p-8">
          <h1 className="font-heading text-3xl font-black tracking-tight mb-1">Masuk</h1>
          <p className="text-zinc-500 text-sm mb-6">Selamat datang kembali di EventKu.</p>
          <form onSubmit={submit} className="space-y-4">
            <div>
              <Label className="text-xs uppercase tracking-widest text-zinc-400">Email</Label>
              <Input data-testid="login-email" type="email" required value={email} onChange={(e) => setEmail(e.target.value)}
                className="mt-1.5 bg-zinc-900 border-zinc-800 focus:ring-primary focus:border-primary rounded-none" placeholder="anda@email.com" />
            </div>
            <div>
              <Label className="text-xs uppercase tracking-widest text-zinc-400">Password</Label>
              <Input data-testid="login-password" type="password" required value={password} onChange={(e) => setPassword(e.target.value)}
                className="mt-1.5 bg-zinc-900 border-zinc-800 focus:ring-primary focus:border-primary rounded-none" placeholder="••••••••" />
            </div>
            {error && <p data-testid="login-error" className="text-sm text-secondary">{error}</p>}
            <Button data-testid="login-submit" type="submit" disabled={loading}
              className="w-full bg-primary text-black font-bold hover:bg-cyan-300 rounded-none h-11">
              {loading ? "Memproses..." : "Masuk"}
            </Button>
          </form>
          <p className="text-sm text-zinc-500 mt-6 text-center">
            Belum punya akun?{" "}
            <Link to="/register" data-testid="go-register" className="text-primary font-semibold hover:underline">Daftar</Link>
          </p>
          <SocialOtpAuth />
        </div>
      </div>
    </div>
  );
}
